import { usePermissions } from './usePermissions';

interface InvoiceEditPermissions {
    canEditInvoices: boolean;
    canEditCompletedInvoices: boolean;
    isLoading: boolean;
}

/**
 * Invoice-edit sub-permissions, read from the single feature map PermissionsProvider already
 * holds. See useJobEditPermissions for why this no longer fetches its own prefixed copy: the
 * separate query was unpersisted, so a cold start on a stalled connection left invoices
 * silently read-only for users who do hold invoices.edit.
 */
export function useInvoiceEditPermissions(): InvoiceEditPermissions {
    const { isFeatureAllowed, isLoading } = usePermissions();

    return {
        canEditInvoices: isFeatureAllowed('invoices.edit'),
        canEditCompletedInvoices: isFeatureAllowed('invoices.edit.completed'),
        isLoading,
    };
}
